
export default {
    layout: 'internal-taxi',
    head() {
    return {
      title: this.title + " | Goa Taxi Hub",
      meta: [{
            hid: 'description',
            name: 'description',
            content: this.description
          },

          {
            hid: 'og:title',
            property: 'og:title',
            content: this.title + " | Goa Taxi Hub"
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: this.description
          },

        ],
      };

    },
data() {
    return {
      title: 'Terms and Condtions',
      description:'Experience the ultimate in convenience with our fast and reliable taxi service. Book your ride now with the top-rated cab company in town. Our professional drivers ensure a safe and comfortable journey. Serving  Goa, we offer affordable fares and timely pickups. Trust us for all your transportation needs – whether it’s a quick trip to the airport or a night out on the town. Book your taxi today and enjoy hassle-free travel with Goa Taxi Hub.'
    }
},
    mounted: function () {
        this.$parent.$emit("sentTitle", this.title);
    }
}
